module.exports = __webpack_public_path__ + "svg/illustration-globe.cd48a1b.svg";